var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodTestosterone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECBE67;}\n\t.st1{fill:#F8A087;}\n\t.st2{fill:#6190CB;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:1.7112;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 84.5,
    cy: 102.8,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 124.5,
    cy: 68.9,
    r: 17.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 166.9,
    cy: 67.5,
    r: 9.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 161,
    cy: 83.5,
    r: 5.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 193,
    cy: 97.7,
    r: 5.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 145.7,
    cy: 82.8,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 140.5,
    cy: 30,
    r: 6.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 101.6,
    cy: 73.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 112.7,
    cy: 88.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 97.1,
    cy: 89.7,
    r: 8.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 202,
    cy: 108.5,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 149.9,
    cy: 70.6,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 179.4,
    cy: 85.5,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150.2,
    cy: 48.4,
    r: 10.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 129.1,
    cy: 43.2,
    r: 5.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.3,254.2c45.2,0,81.8-36.3,81.8-81c0-44.7-36.6-81-81.8-81s-81.8,36.3-81.8,81 C58.6,217.9,95.2,254.2,140.3,254.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "91.9,178 91.9,196.4 107.9,205.7 123.9,196.4 123.9,178 107.9,168.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "123.9,178 123.9,196.4 139.9,205.7 155.8,196.4 155.8,178 139.9,168.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "139.8,150.3 139.8,168.8 155.8,178 171.8,168.8 171.8,150.3 155.8,141.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "189.3,144.6 171.7,150.3 171.8,168.8 189.3,174.5 200.2,159.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 123.9,
    y1: 178.1,
    x2: 123.9,
    y2: 161.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 123.9,
    cy: 159.3,
    r: 2.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 171.8,
    y1: 150.3,
    x2: 171.8,
    y2: 134.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 171.8,
    cy: 131.5,
    r: 2.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 92.2,
    y1: 196.4,
    x2: 85.6,
    y2: 200.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 83.3,
    cy: 201.5,
    r: 2.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 188.2,
    y1: 144.9,
    x2: 195.5,
    y2: 142.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 198,
    cy: 141.7,
    r: 2.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodTestosterone);
export default __webpack_public_path__ + "static/media/Blood_testosterone.42396932c1bca753d8d989362fc12290.svg";
export { ForwardRef as ReactComponent };